// extracted by mini-css-extract-plugin
export default {"panel":"Jr_RAKFqES","inner":"nzk3oQ9J6Y","icon":"k0KAO4X9iB","heading":"exHtSf7wEb","blurb":"IFA_IJjHr4","action":"BK7YZF3_5s"};